<template>
  <div
    class="main-div"
  >
    <!--    Name of location field-->
    <v-row>
      <v-col
        @dblclick="$emit('set-edit', true)"
      >
        <text-field
          v-model="formDataComputed.name"
          :field="{
            key: 'name',
            label: $t('locations/location.name')
          }"
          :validation-errors="validationErrors"
          :disabled="!edit && !createMode"
          @clear-validation-errors="$emit('clear-validation-errors', 'name')"
        />
      </v-col>
    </v-row>

    <!--  Main location switch field-->
    <v-row>
      <v-col
        cols="auto"
        @dblclick="$emit('set-edit', true)"
      >
        <checkbox-field
          v-model="formDataComputed.default"
          :config="{
            key: 'default',
            label: $t('locations/location.main_location')
          }"
          :disabled="!edit && !createMode"
          :validation-errors="validationErrors"
          @clear-validation-errors="$emit('clear-validation-errors', 'default')"
        />
      </v-col>
    </v-row>

    <!--  Color picker-->
    <v-row>
      <v-col
        cols="auto"
        @dblclick="$emit('set-edit', true)"
      >
        <v-menu
          offset-y
          max-width="300"
          :disabled="!edit && !createMode"
        >
          <template
            #activator="{ on }"
          >
            <div
              v-on="on"
              style="display: flex; flex-direction: column;"
            >
              <universal-button
                :color="formDataComputed.color || 'grey'"
                dark
                :disabled="!edit && !createMode"
                :label="$t('locations/location.color')"
                style="max-width: 55px;"
              />
              <span
                v-if="validationErrors.color && validationErrors.color[0]"
                style="color: #ff5252; font-size: 12px; line-height: 12px; padding-top: 5px; padding-left: 12px;"
              >
                {{ validationErrors.color[0] }}
              </span>
            </div>
          </template>
          <v-color-picker
            :value="formDataComputed.color"
            mode="hexa"
            hide-inputs
            show-swatches
            @update:color="onUpdateColor"
          />
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextField from '@/global/components/view-layouts/tabs-layout/components/fields/TextField.vue'
import CheckboxField from '@/global/components/view-layouts/tabs-layout/components/fields/CheckboxField.vue'
import UniversalButton from '@/global/components/buttons/UniversalButton.vue'

export default {
  name: 'FormFields',

  components: {
    UniversalButton,
    CheckboxField,
    TextField
  },

  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    edit: {
      type: Boolean,
      default: false
    },
    createMode: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      formDataComputed: {}
    }
  },

  watch: {
    formData: {
      immediate: true,
      deep: true,
      handler (val) {
        this.formDataComputed = val
      }
    }
  },

  methods: {
    onUpdateColor (event) {
      const { hex } = event || {}

      if (hex) {
        this.formDataComputed.color = hex
        this.$emit('clear-validation-errors', 'color')
      }
    }
  }
}
</script>

<style scoped>
.row {
  margin: 25px 0;
}

.row:first-child {
  margin: 0;
}

.col {
  padding: 0;
}

.main-div {
  padding: 12px;
  margin: 12px;
  border-radius: 16px;
  border: 1px solid #E5E7EB;
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
  color: #111827;
  line-height: 20px;
  font-weight: 500;
}
</style>
